import React from 'react';
import SearchWidget from '../../../shared/components/SearchWidget';

const Nights = ({ value, onChoose }) => {
  const wasChange = value[0] === 6 && value[1] === 14 ? false : true;
  return (
    <SearchWidget
      type="range"
      label="количество ночей"
      width={330}
      title={`c ${value[0]} по ${value[1]} ночей`}
      onChoose={onChoose}
      cssClass="nights"
      isChanged={wasChange}
      value={value}
    />
  );
};

export default Nights;
